import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { Container, Divider, Grid, Header, Modal } from 'semantic-ui-react';

import { formatTimestampAsStringWithTimezone } from '../../helpers/dates';
import { formatFullName } from '../../helpers/utils';

export function HealthCheckModal({ activity, onClose, open }) {
  const { t } = useTranslation();
  const students = useSelector((state) => state.students?.list) || [];
  const [preCheckUrl, setPreCheckUrl] = useState('');

  useEffect(() => {
    const url = activity?.checkIn?.preCheck ? new URL(activity?.checkIn?.preCheck) : '';
    setPreCheckUrl(url);
  }, [activity]);

  if (!activity) return null;
  const student = students.find((student) => student.id === activity.student.id);

  return (
    <Modal
      onClose={onClose}
      open={open}
      closeIcon
      size="small"
      closeOnDimmerClick={false}
      data-testid="att-health-check-modal"
    >
      <Modal.Content className="health-check-modal">
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Header size="large">{t('attendance.legacyHealthCheck.title')}</Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column floated="left" width={7}>
              {`${formatFullName(student)} ${student.nickName ? `(${student.nickName})` : ''}`}
            </Grid.Column>
            <Grid.Column floated="right" width={7} textAlign="right">
              {formatTimestampAsStringWithTimezone(activity.activityTime, activity.timezone, 'MM/DD/YYYY')}
            </Grid.Column>
          </Grid.Row>
          <Divider className="margin-top-0" />
          {preCheckUrl && (
            <>
              <Grid.Row>
                <Grid.Column>
                  <Container>
                    <Header size="small">{t('attendance.legacyHealthCheck.symptomsLabel')}</Header>
                    <p>{preCheckUrl.searchParams.getAll('symptoms').join(', ') || '-'}</p>
                  </Container>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Header size="small">{t('attendance.legacyHealthCheck.notesLabel')}</Header>
                  <p>{preCheckUrl.searchParams.get('notes') || '-'}</p>
                </Grid.Column>
              </Grid.Row>
            </>
          )}
        </Grid>
      </Modal.Content>
    </Modal>
  );
}

export default HealthCheckModal;
